import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Spinner from '../Utils/Spinner';
import AppContext from '../Context/AppContext';
import Header from '../Main/Header';

const Seasons = () => {
    const ctx = useContext(AppContext);
    const params = useParams();
    const watchId = params.watchId;
    const [data, setData] = useState();
    const [error, setError] = useState();
    const navigate = useNavigate();

    const url = 'https://api.themoviedb.org/3/tv/' + watchId + '?api_key=d0e6107be30f2a3cb0a34ad2a90ceb6f';
    useEffect(() => {
        axios
            .get(url)
            .then((response) => {
                setData(response.data);
            })
            .catch((error) => {
                const errorMessage = error.response ? error.response.data : error.message;
                setError(errorMessage);
            });
    }, []);

    const openSeason = (season) => {
        navigate('/watch/tv/' + watchId + '/season/' + season + '?title=' + data.original_name);
    };
    return (
        <>
            <div className='h-screen relative'>
                <Header />

                {data && (
                    <>
                        <div className='absolute -z-20 right-0 top-0 h-full w-full'>
                            <img
                                className='h-full w-full object-cover'
                                src={`https://image.tmdb.org/t/p/w500${data.backdrop_path}`}
                                alt=''
                            />
                        </div>

                        <div className='absolute top-0 -z-10 right-0 h-full w-full bg-black opacity-80'></div>
                        <div className='h-5/6 w-screen overflow-y-scroll'>
                            <div className='h-5'></div>
                            <div className='text-white text-xl text-center p-2'>{data.original_name}</div>
                            {data.tagline && <div className='text-white text-xs text-center p-2'>({data.tagline})</div>}
                            <br />

                            {data.seasons.map(function (season, index) {
                                const overview = season.overview;
                                const truncatedOverView =
                                    overview.length > 100 ? overview.substring(0, 250) + '...' : overview;

                                return (
                                    <React.Fragment key={index}>
                                        {!season.name.includes('Specials') && (
                                            <div
                                                className='flex text-white border-gray-600 shadow-md mb-5 cursor-pointer rounded'
                                                onClick={() => openSeason(season.season_number)}
                                            >
                                                <img
                                                    className='sm:h-48 sm:w-36 w-20 h-32 shadow-md rounded-lg m-2 object-cover'
                                                    src={`https://image.tmdb.org/t/p/w400${season.poster_path}`}
                                                    alt=''
                                                />
                                                <div>
                                                    <div className='font-semibold'>{season.name}</div>
                                                    <div className='text-xs font-medium mb-2'>{truncatedOverView}</div>
                                                    <div className='flex justify-between'>
                                                        <span className='text-xs'>
                                                            Episodes: {season.episode_count}
                                                        </span>
                                                        <span className='text-xs'>Aired on: {season.air_date}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </React.Fragment>
                                );
                            })}

                            <div className='h-14'></div>
                        </div>
                    </>
                )}
                {!data && !error && (
                    <div className='h-5/6 w-screen overflow-hidden flex justify-center items-center'>
                        <div className='flex items-center space-x-2'>
                            <Spinner className='spinner-sm' /> <span>Loading</span>
                        </div>
                    </div>
                )}
                {error && (
                    <div className='h-5/6 bg-backgroundSecondary w-screen overflow-hidden flex justify-center items-center'>
                        <div className='flex items-center space-x-2'>
                            <span className='text-error'>{error}</span>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Seasons;
